<!--
 * @Description: 属性tab内容
 * @Date: 2022-03-08 13:59:54
 * @LastEditTime: 2023-05-04 15:21:29
-->
<template>
  <a-table
    :pagination="pagination"
    @change="handleTableChange"
    :columns="columns"
    :data-source="data"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'dataType'">
        <div>
          <svg-icon
            style="margin-right: 8px; font-size: 16px; cursor: pointer"
            icon-class="book"
            @click="seeDetail(record)"
          />
          <span>{{ record.dataType }}</span>
          <!-- <a @click.prevent="seeDetail(record)">查看</a> -->
        </div>
      </template>
    </template>
  </a-table>
  <Drawer title="扩展信息" v-model:visible="showExpandDrawer" :width="500" :footer="false">
    <ExpandTable :record="selectRecord" />
  </Drawer>
</template>
<script>
import { defineComponent, ref, reactive } from "vue";
import Drawer from "@/components/model/drawer";
import ExpandTable from "@/components/model/model-definition/expand-table/index.vue";
const columns = [
  {
    title: "属性编码",
    dataIndex: "identifier",
    key: "identifier",
    ellipsis: true
  },
  {
    title: "名称",
    dataIndex: "name",
    key: "name",
    ellipsis: true
  },
  {
    title: "数据类型",
    dataIndex: "dataType",
    key: "dataType"
  }
];
export default defineComponent({
  components: {
    ExpandTable,
    Drawer
  },
  props: {
    data: Array
  },
  setup(props) {
    const pagination = reactive({
      showTotal: (total) => `共 ${total} 项数据`,
      current: 1,
      pageSize: 5,
      total: props.data.length
    });

    const handleTableChange = (info) => {
      pagination.current = info.current;
    };

    let showExpandDrawer = ref(false);
    let selectRecord = ref();
    const seeDetail = (record) => {
      selectRecord.value = record;
      showExpandDrawer.value = true;
    };
    // 判断是否有扩展信息
    const haveExpand = (record) => {
      if (record.specifications && record.specifications.length) {
        return true;
      }
      if (record.specification && JSON.stringify(record.specification) !== "{}") {
        return true;
      }
      return false;
    };
    return {
      columns,
      seeDetail,
      showExpandDrawer,
      selectRecord,
      haveExpand,
      pagination,
      handleTableChange
    };
  }
});
</script>
